export default __webpack_public_path__ + "static/Years2001-166edd6c382f442941c302a1270dedd5.jpeg";